// @flow

import {
  STATUS_LOADING,
  STATUS_FAILURE,
  STATUS_SUCCESS,
  STATUS_DEFAULT,
  STATUS_UNKNOWN
} from 'constants/statusConstants';
import {
  FETCH_PAGE_DETAIL_START,
  FETCH_PAGE_DETAIL_SUCCESS,
  FETCH_PAGE_DETAIL_FAILURE,
  FETCH_CUSTOM_PAGE_DETAIL_START,
  FETCH_CUSTOM_PAGE_DETAIL_SUCCESS,
  FETCH_CUSTOM_PAGE_DETAIL_FAILURE,
  FETCH_UNKNOWN
} from 'actions/pageActions';

import type { DocumentType, MemberType, DepartmentType, ArbitreType } from 'types/PageDetail';
import type { ActionType } from 'types/Actions';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { SEOMetaType } from 'types/SEOType';
import type { AcademieType } from 'types/Academie';
import { nullSeoMeta } from 'types/SEOType';

export type State = SEOMetaType & {
  title: string,
  content: Array<BlocContent>,
  slug: string,
  label: Object,
  featured_media: {
    src: string,
    legend: string
  },
  status: Status,
  documents: Array<DocumentType>,
  membersGroups: Array<{
    name: string,
    child: Array<MemberType>
  }>,
  liste_enfants: Array<any>,
  departmentsGroups: Array<DepartmentType>,
  arbitresGroups: Array<ArbitreType>,
  academies: Array<AcademieType>,
  sidebar_content: Array<BlocContent>,
  template: string,
  redirection: string,
};

const initialState: State = {
  ...nullSeoMeta,
  title: '',
  content: [],
  slug: '',
  featured_media: {
    src: '',
    legend: ''
  },
  status: STATUS_DEFAULT,
  documents: [],
  membersGroups: [],
  departmentsGroups: [],
  arbitresGroups: [],
  academies: [],
  liste_enfants: [],
  sidebar_content: [],
  template: '',
  label: {},
  redirection: '',
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_PAGE_DETAIL_START:
    case FETCH_CUSTOM_PAGE_DETAIL_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_PAGE_DETAIL_SUCCESS:
    case FETCH_CUSTOM_PAGE_DETAIL_SUCCESS:
      return {
        ...state,
        title: action.payload.pageDetail.title,
        label: action.payload.pageDetail.label || {},
        content: action.payload.pageDetail.content,
        slug: action.payload.pageDetail.slug,
        featured_media: action.payload.pageDetail.featured_media,
        documents: action.payload.pageDetail.documents,
        membersGroups: action.payload.pageDetail.membersGroups,
        departmentsGroups: action.payload.pageDetail.departmentsGroups,
        arbitresGroups: action.payload.pageDetail.arbitresGroups,
        academies: action.payload.pageDetail.academies,
        sidebar_content: action.payload.pageDetail.sidebar_content,
        meta_description: action.payload.pageDetail.meta_description,
        meta_title: action.payload.pageDetail.meta_title,
        template: action.payload.pageDetail.template,
        liste_enfants: action.payload.pageDetail.liste_enfants,
        redirection: action.payload.pageDetail.redirection,
        status: STATUS_SUCCESS
      };
    case FETCH_PAGE_DETAIL_FAILURE:
    case FETCH_CUSTOM_PAGE_DETAIL_FAILURE:
      return {
        ...state,
        status: STATUS_FAILURE
      };
    case FETCH_UNKNOWN:
      return {
        ...state,
        status: STATUS_UNKNOWN,
      };
    default:
      return state;
  }
}
